export const config = {
  loaders: [
    {
      locale: "ja",
      key: "about",
      loader: () => ({
        title: "とまりぎ亭とは",
        header: "とまりぎ亭とは",
        points: [
          "フリーのギャルゲー＆インディゲーム・クリエイターたちによる依頼受注サイトです。",
          "メンバーはいずれも社会性やメンタル面において信用のおける面々です。",
          "ギャルゲーをゼロから作りはじめて完成させることのできる人材が揃っています。",
          "中国語OK！　中国語圏からのご依頼大歓迎です。日本から中国語圏への依頼の仲介・代行も承ります。",
        ],
        skit: {
          title: "とまりぎ亭 小劇場",
          overture:
            "ここはとある隠れ宿《とまりぎ亭》。閑静にして風光明媚、絵描きや作家が好んで長期滞在しアトリエとしても利用するその旅館は、女主人と一人の料理人、一匹の猫、そして一羽の鳥によって切り盛りされている――",
        },
        skits: {
          "0": "《とまりぎ亭》なら朝飯前です！",
          "1": "ホウレンソウはアリです！",
          "2": "バンドメンバー募集　当方“ボーカル以外全部”！",
          "3": "中国語翻訳依頼熱烈歓迎！",
        },
        characters: [
          {
            name: "翡翠",
            name_en: "Hisui",
            description:
              "ある時、森の中の忘れられた屋敷にふらりと流れつき、旅館《とまりぎ亭》を始めた女主人。旅館を切り盛りしつつ余暇に小説を書いているが、ついつい本業との作業時間が逆転しがち。普通の人間のフリをしているものの、いくつ年を重ねても見た目が変わらない。ニオとゴイちゃんのことは、どちらも自分のペットだと思っている。",
            icon: "chara_hisui",
          },
          {
            name: "ニオ",
            name_en: "Nio",
            description:
              "翡翠に拾われた猫。少なくとも拾われた時はごく普通の子猫だった。《とまりぎ亭》の客から可愛がられるうちに少々育ちすぎた(？)ようだ。天真爛漫、自由奔放で《とまりぎ亭》の人々や周囲の自然を絵に描くのが好き。ゴイちゃんのことを自分のペットだと思っている。",
            icon: "chara_nio",
          },
          {
            name: "ゴイちゃん",
            name_en: "Goi-chan",
            description:
              "翡翠が《とまりぎ亭》を始める前から屋敷に住みついていた妖鳥。《五位の火》という由緒ある妖怪なのだが、ゆるい見た目のせいで誰にも畏れられていない。今はニオの頭の上が定位置で、ニオが大きくなりすぎた(？)のはおそらくこいつの妖気のせい。自分が翡翠とニオの面倒を見ていると思っている。",
            icon: "chara_goi",
          },
          {
            name: "比座間",
            name_en: "Hizama",
            description:
              "《とまりぎ亭》の料理番。どんな料理もなんでもござれ。とくに得意なのは和食。客として《とまりぎ亭》にやってきて自炊しながら逗留していたところを、翡翠にスカウトされた。本来は生真面目で引っ込み思案なのだが、霊感が強く何かと引き寄せやすい体質で、しばしばおかしなモノに憑かれている。叩けば直るが、できればもっと優しく直してほしい。",
            icon: "chara_hizama",
          },
        ],
        credits: "文：雪丸仟　絵：まんごープリン",
      }),
    },
    {
      locale: "ja",
      key: "artist",
      loader: () => ({
        schedule: {
          schedule: "スケジュール",
          available_plenty: "余裕あり",
          available: "空きあり",
          not: "依頼不可",
          not_yet: "未受付",
        },
        achievements: "活動実績",
      }),
    },
    {
      locale: "ja",
      key: "artists",
      loader: () => ({
        title: "作家一覧",
        header: "作家一覧",
        button: "詳細",
        request: "ご依頼はこちら",
        back: "作家一覧に戻る",
      }),
    },
    {
      locale: "ja",
      key: "common",
      loader: () => ({
        title: "《とまりぎ亭》",
        meta: "《とまりぎ亭》は、フリーのクリエイターたちが集う依頼受注サイトです。イラスト、シナリオ、スクリプト等々、多岐にわたる人材で御社のコンテンツ制作をお手伝いさせていただきます。",
        header: {
          about: {
            ja: "とまりぎ亭とは",
            en: "ABOUT TOMARIGITEI",
          },
          artists: {
            ja: "作家一覧",
            en: "ARTISTS",
          },
          request: "ご依頼はこちら",
          language: {
            ja: "日本語",
            zh_CN: "中国語（簡体）",
            zh_TW: "中国語（繁体）",
          },
        },
      }),
    },
    {
      locale: "ja",
      key: "request",
      loader: () => ({
        title: "ご依頼フォーム",
        header: "ご依頼フォーム",
        content_1: [
          "ご依頼の流れ",
          "《とまりぎ亭》は、フリーランスのクリエイターたちが集い運営する、依頼受注サイトです。 クライアント様は、このページ下部のメールフォームを介して、ご希望のクリエイターにご依頼することができます。",
          "メールフォームに必要事項をご記入の上、クリエイターを選択して、メールをご送信ください。",
          "※記入情報は、各クリエイターおよび当サイト窓口へのメール送信にのみ利用させていただきます。",
          "お返事は、クリエイター本人あるいはクリエイター指名の代理人から差しあげます。",
          "※《とまりぎ亭》は制作会社ではなく、あくまで依頼受注の場ですので、クリエイターや案件によって対応が異なりますこと、ご了承いただけますと幸いです。",
          "※クリエイター個人ではなく法人とのお取引・ご契約をご希望の場合は、その旨お申しつけください。",
        ],
        content_2: [
          "ご記入を推奨する情報",
          "ご依頼の際は、あらかじめ以下の情報をご教示いただけますと、お話をスムーズに進められます。NDA（秘密保持契約）締結が必要な場合でも、可能な範囲内でできるだけご教示いただけますと幸いです。",
          "リリース媒体・ジャンル",
          "おおもとのクライアント様のお名前　※パブリッシャー、デベロッパー等",
          "作業内容",
          "報酬金額・ご予算　※消費税別・振込手数料別",
          "納期",
          "著作権の扱い　※買取か否か",
          "実績公開の可否、公開方法・条件",
        ],
        content_3: [
          "おことわり",
          "個人からのご依頼で、サークル等での活動実態のないものにつきましては、当サイトでは受けつけておりません。各クリエイターへ直接お問い合わせください。",
          "クリエイター登録など具体的なご依頼のないご相談は、当サイトでは受けつけておりません。",
        ],
        form: {
          name: "お名前",
          email: "メールアドレス",
          subject: "ご依頼のクリエイター",
          message: "ご依頼内容",
          require: "必須",
        },
        button: {
          check: "確認する",
          submit: "送信",
          fix: "修正する",
        },
        thanks: {
          title: "送信完了",
          content:
            "ご依頼ありがとうございます。お返事までいましばらくお待ちください。自動送信の折り返しメールが届いていない、あるいは一週間が過ぎてもお返事がない場合は、お手数ではございますが、フッターのメールからお問い合わせいただけますと幸いです。",
          button: "トップページへ",
        },
      }),
    },
    {
      locale: "ja",
      key: "top",
      loader: () => ({
        carousel_detail: "作家の詳細はこちら→",
        topics: [
          {
            title: "about",
            base: "とまりぎ亭とは",
            en: "ABOUT TOMARIGITEI",
            popup:
              "フリーランスの作家たちによる依頼受注サイト、それが《とまりぎ亭》だ。",
            link: "about",
            img: "top_btn01",
          },
          {
            title: "artists",
            base: "作家一覧",
            en: "ARTISTS",
            popup: "絵師や脚本家から裏方まで、多様な職人が集っているぞ。",
            link: "artists",
            img: "top_btn02",
          },
          {
            title: "request",
            base: "ご依頼はこちら",
            en: "REQUEST FORM",
            popup: "お眼鏡にかなう作家がいたら、ここから連絡するのだ。",
            link: "request",
            img: "top_btn03",
          },
          {
            title: "twitter",
            base: "X/TWITTER",
            popup: "フォローして最新情報をチェック！",
            link: "https://twitter.com/tomarigitei",
            img: "",
          },
          {
            title: "cien",
            base: "Ci-en",
            popup: "作家たちによる自由帳だ。ご支援ヨロシク！",
            link: "https://ci-en.dlsite.com/creator/14687",
            img: "",
          },
          {
            title: "pixiv",
            base: "pixiv",
            popup: "作家たちが手がけた仕事の一部を公開しているぞ。",
            link: "https://www.pixiv.net/users/85403931",
          },
        ],
        header: "News",
      }),
    },
    {
      locale: "zh-cn",
      key: "about",
      loader: () => ({
        title: "关于栖木亭",
        header: "关于栖木亭",
        points: [
          "栖木亭是免费开放的业务中介网站，由来自美少女游戏、独立游戏业界的创作者组成。",
          "成员们均拥有足以信赖的业界声誉与千锤百炼的精神力。",
          "仅凭我们的成员，就足以完成一部美少女游戏从0至100的全部开发工序。",
          "本站支持中文！您可以用中文直接进行委托。我们也可以帮忙完成中日之间的业务中介。",
        ],
        skit: {
          title: "栖木亭小剧场",
          overture:
            "这里是远离市井的小旅馆「栖木亭」。清静闲适，风光秀美，很多画师与写手长期居住于此，从事各自的创作。经营旅馆的是一位女主人，一名厨师，一只猫与一只鸟——",
        },
        skits: {
          "0": "一切包在「栖木亭」身上！",
          "1": "菠菜守则要遵守！",
          "2": "第三话　来组乐队吧！招募除「歌手之外全部成员」！",
          "3": "中国语翻译依赖热烈欢迎！",
        },
        characters: [
          {
            name: "翡翠",
            name_en: "Hisui",
            description:
              "某天无意发现了被遗弃在森林里的宅第，于是将其改造成旅馆「栖木亭」并当起了女主人。会在经营的同时忙里偷闲地创作小说，但经常不知不觉地把工作时间也投入其中。平时表现得像个普通人，但无论多少年过去也毫无衰老的迹象。尼欧和小五都被她视作宠物。",
            icon: "chara_hisui",
          },
          {
            name: "尼欧",
            name_en: "Nio",
            description:
              "被翡翠收留的野猫。当时还只是普通的小猫，后来在客人们的疼爱下似乎有些成长过度……性格天真烂漫，自由奔放，喜欢用画笔记录下与栖木亭相关的人，以及周围的自然风光。单方面把小五视为自己的宠物。",
            icon: "chara_nio",
          },
          {
            name: "小五",
            name_en: "Goi-chan",
            description:
              "早在栖木亭开业以前就居住在那里的妖鸟。其真身是声名显赫的妖怪「五位之火」，但因外表呆萌而完全不受到任何人的敬畏。如今往往盘踞在尼欧头顶，估计也是它散发的妖气让尼欧野蛮成长到如今这副模样吧。单方面地认为翡翠和尼欧都在蒙受自己的照顾。",
            icon: "chara_goi",
          },
          {
            name: "比座间",
            name_en: "Hizama",
            description:
              "栖木亭的厨师长。任何饭菜都做得出来，其中尤其擅长和风料理。原本是以顾客身份居住在这里，结果在自炊时受到了翡翠的聘请。生性耿直，深谋远虑，但强大的通灵体质极易引来各种神秘事物，偶尔也会被恶灵附体。虽然敲一敲就能恢复，但可能的话还是采取更温柔的手段吧。",
            icon: "chara_hizama",
          },
        ],
        credits: "文：雪丸仟　绘：芒果布丁",
      }),
    },
    {
      locale: "zh-cn",
      key: "artist",
      loader: () => ({
        schedule: {
          schedule: "工作计划",
          available_plenty: "时间充足",
          available: "存在空闲",
          not: "已无空闲",
          not_yet: "暂未开放",
        },
        achievements: "参与作品",
      }),
    },
    {
      locale: "zh-cn",
      key: "artists",
      loader: () => ({
        title: "作家一览",
        header: "作家一览",
        button: "详情",
        request: "前往委托窗口",
        back: "返回作家一览",
      }),
    },
    {
      locale: "zh-cn",
      key: "common",
      loader: () => ({
        title: "「栖木亭」",
        meta: "「栖木亭」是由自由创作者组成的业务中介网站。这里拥有插画师、剧本家、脚本设计师等众多领域的人才，可以帮助您完成自己的作品。",
        header: {
          about: {
            ja: "关于栖木亭",
            en: "ABOUT TOMARIGITEI",
          },
          artists: {
            ja: "作家一览",
            en: "ARTISTS",
          },
          request: "委托窗口",
          language: {
            ja: "日本語",
            zh_CN: "简体中文",
            zh_TW: "中国語（繁体）",
          },
        },
      }),
    },
    {
      locale: "zh-cn",
      key: "request",
      loader: () => ({
        title: "委托窗口",
        header: "委托窗口",
        content_1: [
          "委托流程",
          "栖木亭是由一群游戏创作者组建并运营的业务中介网站。请委托人填写以下表格，与需要的创作者取得联系。",
          "填写必须项目后选择想要聘请的创作者，即可发送邮件。",
          "※您提供的信息将只会被用来提供内各个创作者以及本委托窗口的邮件发送程序。",
          "随后将由创作者本人，或创作者指定的代理人予以回信。",
          "※栖木亭并非负责开发制作的公司，而是只提供业务中介的平台。不同创作者、不同委托在执行过程中存在个体差异，需要更多的具体交流，敬请理解。",
          "※若需要与个人创作者缔结企业级别的契约，请在委托中明确说明。",
        ],
        content_2: [
          "推荐提供的信息",
          "即使需要缔结保密协议，也请在可能范围内提供以下信息，使双方的合作过程更加顺利。",
          "作品发布平台与作品种类",
          "上级委托人名称　※开发商、发行商等",
          "具体委托内容",
          "报酬金额与预算　※不含消费税与汇款手续费",
          "截稿日期",
          "著作权归属　※是否完全收购",
          "是否允许创作者在一定条件下公开实绩",
        ],
        content_3: [
          "注意",
          "本站不接受不存在集体、社团名义或具体运用目标的委托。若有仅供私人用途的委托，请直接与创作者本人取得联系。",
          "本站不接受对创作者进行拉拢等不存在具体委托的咨询。",
        ],
        form: {
          name: "委托者名称",
          email: "邮箱地址",
          subject: "希望聘请的创作者",
          message: "委托内容",
          require: "必须条件",
        },
        button: {
          check: "确定",
          submit: "发送",
          fix: "修改",
        },
        thanks: {
          title: "已发送",
          content:
            "多谢您的信赖，请耐心等待创作者的回信。若没有受到确认此次委托的自动回信，又或在一周之内没有受到正式的回答，麻烦您通过末尾处的邮箱进行咨询。",
          button: "返回首页",
        },
      }),
    },
    {
      locale: "zh-cn",
      key: "top",
      loader: () => ({
        carousel_detail: "关于作家的具体情报→",
        topics: [
          {
            title: "about",
            base: "关于栖木亭",
            en: "ABOUT TOMARIGITEI",
            popup: "「栖木亭」是由一群自由创作者组成的业务中介网站。",
            link: "about",
            img: "top_btn01",
          },
          {
            title: "artists",
            base: "作家一览",
            en: "ARTISTS",
            popup: "画师、写手、幕后人员……各种专业人才齐聚一堂！",
            link: "artists",
            img: "top_btn02",
          },
          {
            title: "request",
            base: "委托窗口",
            en: "REQUEST FORM",
            popup: "若遇到符合要求的作家，请与我们取得联系！",
            link: "request",
            img: "top_btn03",
          },
          {
            title: "twitter",
            base: "X/TWITTER",
            popup: "关注我们，获取最新情报！",
            link: "https://twitter.com/tomarigitei",
            img: "",
          },
          {
            title: "cien",
            base: "Ci-en",
            popup: "这里是供作家们任意发挥的空间。敬请支持！",
            link: "https://ci-en.dlsite.com/creator/14687",
            img: "",
          },
          {
            title: "pixiv",
            base: "pixiv",
            popup: "部分作家的工作成果也会在这里得到展示哦！",
            link: "https://www.pixiv.net/users/85403931",
            img: "",
          },
        ],
        header: "News",
      }),
    },
    {
      locale: "zh-tw",
      key: "about",
      loader: () => ({
        title: "關於棲木亭",
        header: "關於棲木亭",
        points: [
          "棲木亭是免費開放的業務中介網站，由來自美少女遊戲、獨立遊戲業界的創作者組成。",
          "成員們均擁有足以信賴的業界聲譽與千錘百鍊的精神力。",
          "僅憑我們的成員，就足以完成一部美少女遊戲從0至100的全部開發工序。",
          "本站支持中文！您可以用中文直接進行委託。我們也可以幫忙完成中日之間的業務中介。",
        ],
        skit: {
          title: "棲木亭小劇場",
          overture:
            "這裡是遠離市井的小旅館「棲木亭」。清靜閒適，風光秀美，很多畫師與寫手長期居住於此，從事各自的創作。經營旅館的是一位女主人，一名廚師，一隻貓與一隻鳥",
        },
        skits: {
          "0": "一切包在「棲木亭」身上！",
          "1": "菠菜守則要遵守！",
          "2": "第三話　來組樂隊吧！招募除「歌手之外全部成員」！",
          "3": "中國語翻譯依賴熱烈歡迎！",
        },
        characters: [
          {
            name: "翡翠",
            name_en: "Hisui",
            description:
              "某天無意發現了被遺棄在森林裡的宅第，於是將其改造成旅館「棲木亭」並當起了女主人。會在經營的同時忙裡偷閒地創作小說，但經常不知不覺地把工作時間也投入其中。平時表現得像個普通人，但無論多少年過去也毫無衰老的跡象。尼歐和小五都被她視作寵物。",
            icon: "chara_hisui",
          },
          {
            name: "尼歐",
            name_en: "Nio",
            description:
              "被翡翠收留的野貓。當時還隻是普通的小貓，後來在客人們的疼愛下似乎有些成長過度……性格天真爛漫，自由奔放，喜歡用畫筆記錄下與棲木亭相關的人，以及周圍的自然風光。單方面把小五視為自己的寵物。",
            icon: "chara_nio",
          },
          {
            name: "小五",
            name_en: "Goi-chan",
            description:
              "早在棲木亭開業以前就居住在那裡的妖鳥。其真身是聲名顯赫的妖怪「五位之火」，但因外表呆萌而完全不受到任何人的敬畏。如今往往盤踞在尼歐頭頂，大概也是它散發的妖氣讓尼歐野蠻成長到如今這副模樣吧。單方面地認為翡翠和尼歐都在蒙受自己的照顧。",
            icon: "chara_goi",
          },
          {
            name: "比座間",
            name_en: "Hizama",
            description:
              "棲木亭的廚師長。任何飯菜都做得出來，其中尤其擅長和風料理。原本是以顧客身份居住在這裡，結果在自炊時受到了翡翠的聘請。生性耿直，深謀遠慮，但強大的通靈體質極易引來各種神秘事物，偶爾也會被惡靈附體。雖然敲一敲就能恢復，但可能的話還是採取更溫柔的手段吧。",
            icon: "chara_hizama",
          },
        ],
        credits: "文：雪丸仟　繪：芒果布丁",
      }),
    },
    {
      locale: "zh-tw",
      key: "artist",
      loader: () => ({
        schedule: {
          schedule: "工作計劃",
          available_plenty: "時間充足",
          available: "存在空閒",
          not: "已無空閒",
          not_yet: "暫未開放",
        },
        achievements: "參與作品",
      }),
    },
    {
      locale: "zh-tw",
      key: "artists",
      loader: () => ({
        title: "作家一覽",
        header: "作家一覽",
        button: "詳情",
        request: "前往委託窗口",
        back: "返回作家一覽",
      }),
    },
    {
      locale: "zh-tw",
      key: "common",
      loader: () => ({
        title: "「棲木亭」",
        meta: "「棲木亭」是由自由創作者組成的業務中介網站。這裡擁有插畫師、劇本家、腳本設計師等眾多領域的人才，可以幫助您完成自己的作品。",
        header: {
          about: {
            ja: "關於棲木亭",
            en: "ABOUT TOMARIGITEI",
          },
          artists: {
            ja: "作家一覽",
            en: "ARTISTS",
          },
          request: "委託窗口",
          language: {
            ja: "日本語",
            zh_CN: "中国語（簡体）",
            zh_TW: "繁體中文",
          },
        },
      }),
    },
    {
      locale: "zh-tw",
      key: "request",
      loader: () => ({
        title: "委託窗口",
        header: "委託窗口",
        content_1: [
          "委託流程",
          "棲木亭是由一群遊戲創作者組建並運營的業務中介網站。請委託人填寫以下表格，與需要的創作者取得聯繫。",
          "填寫必須項目後選擇想要聘請的創作者，即可發送郵件。",
          "※您提供的資訊將只會被用來提供內各個創作者以及本委託窗口的郵件發送程序。",
          "隨後將由創作者本人，或創作者指定的代理人予以回信。",
          "※棲木亭並非負責開發製作的公司，而是只提供業務中介的平台。不同創作者、不同委託在執行過程中存在個體差異，需要更多的具體交流，敬請理解。",
          "※若需要與個人創作者締結企業級別的契約，請在委託中明確說明。",
        ],
        content_2: [
          "推薦提供的資訊",
          "即使需要締結保密協議，也請在可能範圍內提供以下資訊，使雙方的合作過程更加順利。",
          "作品發布平台與作品種類",
          "上級委託人名稱　※開發商、發行商等",
          "具體委託內容",
          "報酬金額與預算　※不含消費稅與匯款手續費",
          "截稿日期",
          "著作權歸屬　※是否完全收購",
          "是否允許創作者在一定條件下公開此次履歷",
        ],
        content_3: [
          "注意",
          "本站不接受不存在集體、社團名義或具體運用目標的委託。若有僅供私人用途的委託，請直接與創作者本人取得聯繫。",
          "本站不接受對創作者進行拉攏等不存在具體委託的諮詢。",
        ],
        form: {
          name: "委託者名稱",
          email: "信箱地址",
          subject: "希望聘請的創作者",
          message: "委託內容",
          require: "必須條件",
        },
        button: {
          check: "確定",
          submit: "發送",
          fix: "修改",
        },
        thanks: {
          title: "已發送",
          content:
            "多謝您的信賴，請耐心等待創作者的回信。若沒有受到確認此次委託的自動回信，又或在一週之內沒有受到正式的回答，麻煩您通過末尾處的信箱進行諮詢。",
          button: "返回首頁",
        },
      }),
    },
    {
      locale: "zh-tw",
      key: "top",
      loader: () => ({
        carousel_detail: "關於作家的具體情報→",
        topics: [
          {
            title: "about",
            base: "關於棲木亭",
            en: "ABOUT TOMARIGITEI",
            popup: "「棲木亭」是由一群自由創作者組成的業務中介網站。",
            link: "about",
            img: "top_btn01",
          },
          {
            title: "artists",
            base: "作家一覽",
            en: "ARTISTS",
            popup: "畫師、寫手、幕後人員……各種專業人才齊聚一堂！",
            link: "artists",
            img: "top_btn02",
          },
          {
            title: "request",
            base: "委託窗口",
            en: "REQUEST FORM",
            popup: "若遇到符合要求的作家，請與我們取得聯繫！",
            link: "request",
            img: "top_btn03",
          },
          {
            title: "twitter",
            base: "X/TWITTER",
            popup: "關注我們，獲取最新情報！",
            link: "https://twitter.com/tomarigitei",
            img: "",
          },
          {
            title: "cien",
            base: "Ci-en",
            popup: "這裡是供作家們任意發揮的空間。敬請支持！",
            link: "https://ci-en.dlsite.com/creator/14687",
            img: "",
          },
          {
            title: "pixiv",
            base: "pixiv",
            popup: "部分作家的工作成果也會在這裡得到展示哦！",
            link: "https://www.pixiv.net/users/85403931",
            img: "",
          },
        ],
        header: "News",
      }),
    },
  ],
};
